/**
 * FBSBancaRIOBAMBA
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UsuarioPreguntaMLS } from './usuarioPreguntaMLS';


export interface ObtenerPerfilMS { 
    transferenciaInternaMontoDiario?: number;
    transferenciaInternaMontoMensual?: number;
    transferenciaExternaMontoDiaria?: number;
    transferenciaExternaMontoMensual?: number;
    transferenciaInternaMontoDiarioMaximo?: number;
    transferenciaInternaMontoMensualMaximo?: number;
    transferenciaExternaMontoDiariaMaximo?: number;
    transferenciaExternaMontoMensualMaximo?: number;
    enviaCorreo?: boolean;
    enviaSMS?: boolean;
    usaClaveDigital?: boolean;
    usuarioPreguntas?: Array<UsuarioPreguntaMLS> | null;
}

